export const CREDENTIALS = {
  app: 'KJ7GJHLEXC',
  key: 'b8126dbcf8240cf84900054a2dff7dcb',
};
